module.exports = __webpack_public_path__ + "assets/LDivide3Detailed.be77e081636bae5baf481846614e4afc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/LDivide3Detailed.png
// module id = 529
// module chunks = 0